// extracted by mini-css-extract-plugin
export default {"infoText":"Exports_infoText__fzLob"};